import React, { useEffect,useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const LogMode = ({months}) => {
  return (
    <div className="LogMode">
      {months.map((month)=>{
        return (
          <>
            <h1 className="monthName">
              {month.month}
            </h1>
            <div>
              {month.weeks.map((week) => {
                return (
                  <>
                    <p className="week">
                      { week.title}
                    </p>
                    <div className="cells">
                      <div className="custom_cell">
                        <div className="left_cell">
                          <div className="border">
                            <b>Date</b>
                          </div>
                        </div>
                        <div className="right_cell">
                          <div className="border">
                            <b>Tasks</b>
                          </div>
                        </div>
                      </div>

                      {week.tasks.map((task) => {
                        return (
                          <div className="custom_cell cell_date">
                            <div className="left_cell">
                              <div className="border">
                                {task.date}
                              </div>
                            </div>
                            <div className="right_cell">
                              <div className="border">
                                {task.task}
                              </div>
                            </div>
                          </div>
                        )
                      })}

                      
                    </div>
                  </>
                )
              })}
            </div>
          </>
        )
      })}
      
    </div>
  )
}

const CalendarMode = (months) => {
  return (
    <div>
      CalendarMode
    </div>
  )
}
const Notebook = () => {
  
  const [mode, setMode] = useState("log")

  const months = [
    {
      month:"April",
      weeks:[
        {
          title:"Week 1: 24-30 April 2022",
          tasks:[
            {
              date: "27 Apr",
              task: "Assemble pUNA-HR-nsrQOP by ClonExpress Ultra One Step Cloning Kit. "
            },
            {
              date: "29 Apr",
              task: "Prepare fragments nsrQ, nsrO, AacuE for pUNA-HR-nsrQOE. "
            }
          ]
        }
      ]
    },
    {
      month: "May",
      weeks: [
        {
          title: "Week 2: 1-7 May 2022",
          tasks: [
            {
              date: "2 May",
              task: "Assemble of pUNA-HR-nsrQFP and pUNA-HR-nsrQFE using In-Fusion Snap Assembly master mix. pUNA-HR-nsrQFP is successful; pUNA-HR-nsrQFE failed, transformation repeated on 4/5/2022 with pre-culturing step. "
            },
            {
              date: "5 May",
              task: " Large-scale cultivation of DH5α1pUNA-HR-nsrQOP, nsrQOE, nsrQFP. Plasmid extraction. "
            },
            {
              date: "5 May",
              task: "Check the metabolic profile of the host nsrABCDERJIGK + AacuH by LCMS.  "
            },
            {
              date: "6 May",
              task: "Preparation of fungal transformation using the host NSARI/nsrJGKAacuH. "
            }
          ]
        },
        {
          title: "Week 5: 22-28 May 2022",
          tasks: [
            {
              date: "24 May",
              task: "Prepare pTAex3-HR-AacuE and pTAex3-HR-nsrP for bioconversion experiment. "
            },
            {
              date: "27 May ",
              task: "Fungal transformation using the host NSARI/nsrJGKAacuH.  "
            }
          ]
        }
      ]
    },
    {
      month: "June",
      weeks: [
        {
          title: "Week 8: 12-18 June 2022",
          tasks: [
            {
              date: "17 Jun",
              task: "Large-scale cultivation of NSARI/nsrJGKQOAacuHE in 4L culture medium."
            }
          ]
        },
        {
          title: "Week 9: 19-25 June 2022",
          tasks: [
            {
              date: "23 Jun",
              task: "Gene introduction check of nsrQ, nsrO and AacuE by fungal colony PCR. "
            }
          ]
        },
        {
          title: "Week 10: 26 June - 2 July 2022",
          tasks: [
            {
              date: "29 Jun",
              task: "Half of the crude extract from NSARI/nsrJGKQOAacuHE was fractionized by flash chromatography."
            }
          ]
        }
      ]
    },
    {
      month: "July",
      weeks: [
        {
          title: "Week 11: 3-9 July 2022",
          tasks: [
            {
              date: "4 Jul",
              task: "Dimers containing fractions were purified with preparative HPLC."
            },
            {
              date: "5 Jul",
              task: "Dimers containing fractions were purified with preparative HPLC."
            },
            {
              date: "6 Jul",
              task: "Dimers containing fractions were purified with preparative HPLC."
            },
            {
              date: "8 Jul",
              task: "Large-scale cultivation of A. aculeatus for the isolation of secalonic acid D."
            }
          ]
        },
        {
          title: "Week 12: 10-16 July 2022",
          tasks: [
            {
              date: "15 Jul",
              task: "A. aculeatus culture terminated. "
            }
          ]
        },
        {
          title: "Week 13: 17-23 July 2022",
          tasks: [
            {
              date: "17 July ",
              task: "Dimers containing fractions were purified with preparative HPLC."
            }
          ]
        },
        {
          title: "Week 14: 24-30 July 2022",
          tasks: [
            {
              date: "30 Jul",
              task: "Deactivation of PyrG in NSARI/nsrJGKAacuH to obtain a PyrG- mutant."
            }
          ]
        }
      ]
    },
    {
      month: "August",
      weeks: [
        
        {
          title: "Week 15: 31 July - 6 August 2022",
          tasks: [
            {
              date: "1 Aug",
              task: "Crude extract of A. aculeatus was fractionized by flash chromatography. "
            },
            {
              date: "5 Aug",
              task: "Prepare stock solutions for NMR stability test and in vitro test."
            }
          ]
        },
        {
          title: "Week 16: 7-13 August 2022",
          tasks: [
            {
              date: "8 Aug",
              task: "Prepare stock solution for MTT assays. Seed cancer cells HT-29 and A2780 into each different 96-well plates for MTT assays."
            },
            {
              date: "12 Aug ",
              task: "Remaining half of the crude extract from NSARI/nsrJGKQOAacuHE was fractionized by flash chromatography."
            }
          ]
        },
        {
          title: "Week 17: 14- 20 August 2022",
          tasks: [
            {
              date: "18 Aug",
              task: "Dimers containing fractions were purified with preparative HPLC. "
            },
            {
              date: "19 Aug",
              task: "Add prepared drugs (compounds 1 and 2) to cancer cells seeded in the 96-well plates for MTT assays."
            },
            {
              date: "22 Aug",
              task: "Add mixture of media and MTT solution to the wells. Measure the absorbance by using a microplate spectrophotometer. After that, do three biological replicates."
            }
          ]
        },

        {
          title: "Week 18: 21-27 August 2022",
          tasks: [
            {
              date: "22 Aug",
              task: "Add mixture of media and MTT solution to the wells. Measure the absorbance by using a microplate spectrophotometer. After that, do three biological replicates."
            }
          ]
        }
      ]
    }
  ]
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Lab logbook</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="">
        <div className="calend">
          <div>
            <div className="mode_buttons " style={{display:'none'}}>
              <a href="#" className="what_button active">
                Laboratory work log
              </a>
              <a href="#" className="dark_button">
                Calendar mode
              </a>
            </div>
            <div className="modes">
              {
                mode == "log" ?
                  <LogMode months={months} /> :
                  <CalendarMode months={months} />
              }
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}


export default Notebook;
